import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Container, Section, Divider } from './styles';
import * as S from '@/components/Settings/DataExtraction/styles';

interface ActionPlanInfoProps {
	reportName?: string;
	evaluations?: number;
	actionPlansCount?: number;
}

export function ActionPlanInfo({
	reportName = '',
	evaluations = 0,
	actionPlansCount = 0
}: Readonly<ActionPlanInfoProps>) {
	return (
		<Container>
			<Section>
				<S.LabelMediumSemibold>{reportName}</S.LabelMediumSemibold>
			</Section>
			<Divider />
			<Section>
				<S.LabelMediumRegular>
					{I18n.get('Evaluations')}: {evaluations}
				</S.LabelMediumRegular>
			</Section>
			<Divider />
			<Section>
				<S.LabelMediumRegular>
					{I18n.get('Action plans')}: {actionPlansCount}
				</S.LabelMediumRegular>
			</Section>
		</Container>
	);
}
